import React, { useState } from "react";
import "../css/popup.css";
import { useNavigate, useLocation } from "react-router-dom";

export default function Accept_Agent_Application() {
  const navigate = useNavigate();
  const location = useLocation();
  const delivery_agent_id = location.state.id;
  const gender = location.state.gender;
  const [data, getData] = useState([]);
  const token = JSON.parse(sessionStorage.getItem("userToken"));

  const AcceptRegRequest = async () => {
    try {
      const response = await fetch(
        "https://serverpickload.wl.r.appspot.com/admin_reg_request/accept_request",
        {
          method: "POST",

          body: JSON.stringify({
            token: token,
            delivery_agent_id: delivery_agent_id,
            gender: gender,
          }),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          },
        }
      );
      const result = await response.json();
      //console.log(result.delivery_agent);
      getData(result.delivery_agent);
      //console.log('got here');
      //console.log(result);
      //console.log(data.vehicle_details, data.bank_details);

      if (response.status === 200) {
        //console.log("delivery agent accepted successfully");
      } else {
        //console.log("some error occurred");
      }
    } catch (error) {
      //console.log(error);
    }
  };

  return (
    <div className="popup">
      <div className="popup-container">
        <div className="popup-background">
          <div className="popup-confirmation">
            <div className="popup-confirmation-info">
              Accept Agent application <br></br>Confirmation
            </div>
            <div className="popup-rematched">
              Are you sure you want to accept this <br></br>Agent's Application?
            </div>
          </div>
          <div className="popup-dialog-row">
            <div
              className="popup-dialog"
              onClick={() => navigate("/App/Agent_Applications")}
            >
              No
            </div>
            <div className="middle-line">
              <hr className="popup-hr"></hr>
            </div>
            <div
              className="popup-dialog1"
              onClick={() => {
                AcceptRegRequest();
                navigate("/App/Agent_Applications");
              }}
            >
              Yes
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
